module.exports = __webpack_public_path__ + "11fcf53a2d727ad0af37e39a8f890547.svg";